"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ykbUtils = require("ykb-utils");
var _tableContext = require("../../Context/tableContext");
var _filterFns = _interopRequireDefault(require("./../../filterFns"));
var _TestEditableCell = _interopRequireDefault(require("./TestEditableCell"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var FormRow2 = exports.default = /*#__PURE__*/function (_React$PureComponent) {
  function FormRow2(props) {
    var _this;
    (0, _classCallCheck2.default)(this, FormRow2);
    _this = _callSuper(this, FormRow2, [props]);
    _this.setIsRowEditing = _this.setIsRowEditing.bind(_this);
    _this.setIsDeleted = _this.setIsDeleted.bind(_this);
    _this.updateRow = _this.updateRow.bind(_this);
    _this.updateRowByFilter = _this.updateRowByFilter.bind(_this);
    _this.getRowData = _this.getRowData.bind(_this);
    _this.updateRowField = _this.updateRowField.bind(_this);
    _this.setColumns = _this.setColumns.bind(_this);
    _this.clearFilter = _this.clearFilter.bind(_this);
    _this.checkFilter = _this.checkFilter.bind(_this);
    _this.setIsExpanded = _this.setIsExpanded.bind(_this);
    _this.callRelateds = _this.callRelateds.bind(_this);
    _this.isFilterIgnore = _this.isFilterIgnore.bind(_this);
    _this.enableListChildren = _this.enableListChildren.bind(_this);
    _this.onDeleting = _this.onDeleting.bind(_this);
    _this.checkFilterHierarchicallyUpCallback = _this.checkFilterHierarchicallyUpCallback.bind(_this);
    _this.setIsExpandedForExpandedRowKeys = _this.setIsExpandedForExpandedRowKeys.bind(_this);
    var parentRowIndex = props.parentRowIndex,
      rowIndex = props.rowIndex,
      row = props.row,
      _depth = props.depth,
      rowKey = props.rowKey,
      _rowStyle = props.rowStyle,
      prefixCls = props.prefixCls,
      _props$parentRowsPath = props.parentRowsPath,
      parentRowsPath = _props$parentRowsPath === void 0 ? [] : _props$parentRowsPath;
    var depthprefix = (0, _ykbUtils.isNullOrUndefined)(parentRowIndex) ? '' : parentRowIndex + '.';
    _this.rowId = depthprefix + rowIndex;
    _this.rowPath = [].concat((0, _toConsumableArray2.default)(parentRowsPath), [rowKey]);
    _tableContext.eventHub.setState({
      key2id: _objectSpread(_objectSpread({}, _tableContext.eventHub.getState('key2id')), {}, (0, _defineProperty2.default)({}, rowKey, _this.rowId)),
      id2key: _objectSpread(_objectSpread({}, _tableContext.eventHub.getState('id2key')), {}, (0, _defineProperty2.default)({}, _this.rowId, rowKey)),
      rowPaths: _objectSpread(_objectSpread({}, _tableContext.eventHub.getState('rowPaths')), {}, (0, _defineProperty2.default)({}, rowKey, _this.rowPath))
    });
    _this.depth = _depth || 0;
    _this.rowUuid = "row-".concat(rowKey);
    _this.rowStyle = _rowStyle || function () {
      return 'default';
    };
    _this.preparedClass = prefixCls + '-row ';
    _this.getRowKey = _tableContext.eventHub.getState('getRowKey');
    _this.state = {
      isRowEditing: false,
      isDeleted: false,
      isExpanded: !!(_tableContext.eventHub.getState('expandedRowKeys') || {})[rowKey],
      isFiltered: false,
      innerRowValue: row,
      columns: _tableContext.eventHub.getState('columns')
    };
    _this.unsubscriber = [_tableContext.eventHub.on("isEditing.".concat(rowKey), _this.setIsRowEditing), _tableContext.eventHub.on("isDeleted.".concat(rowKey), _this.setIsDeleted), _tableContext.eventHub.on("update.row.".concat(rowKey), _this.updateRow), _tableContext.eventHub.on("update.row.byfilter.".concat(rowKey), _this.updateRowByFilter), _tableContext.eventHub.on("get.rowData.".concat(rowKey), _this.getRowData), _tableContext.eventHub.on("update.row.field.".concat(rowKey), _this.updateRowField), _tableContext.eventHub.on("update.expandable.expandedRowKeys.".concat(rowKey), _this.setIsExpandedForExpandedRowKeys), _tableContext.eventHub.on('update.columns', _this.setColumns), _tableContext.eventHub.on('update.filters.formrow', _this.checkFilter), _tableContext.eventHub.on("update.formrow.isexpanded.".concat(rowKey), _this.setIsExpanded)];
    _this.filterParams = {};
    _this.filteredColumns = [];
    _this.innerRowValueRef = row;
    _this.isFilteredRef = null;
    _this.hierarchicallyFilteredRowKeys = {};
    return _this;
  }

  // #region setState
  (0, _inherits2.default)(FormRow2, _React$PureComponent);
  return (0, _createClass2.default)(FormRow2, [{
    key: "checkFilter",
    value: function checkFilter(_filterParams, forceFilterForUpdateRow) {
      var hasFilter = Object.keys(_filterParams).length > 0;
      if (!hasFilter) {
        this.clearFilter();
      }
      if ((0, _ykbUtils.isEqual)(_filterParams, this.filterParams) && !forceFilterForUpdateRow) {
        return;
      } else {
        this.filteredColumns = Object.keys(_filterParams);
        this.filterParams = _filterParams;
      }
      var _filterStatus = [];
      for (var _key in _filterParams) {
        var _val = _filterParams[_key];
        var _val2 = (0, _toArray2.default)(_val),
          type = _val2[0],
          params = _val2.slice(1);
        var filterFunc = _filterFns.default[type];
        if (typeof filterFunc === 'function') {
          _filterStatus.push(!filterFunc(this.innerRowValueRef, _val));
        }
      }
      var _filtered = _filterStatus.some(function (q) {
        return q;
      });
      this.isFilteredRef = _filtered;
      if (this.isFilterIgnore()) {
        // hiyerarşik olarak açılması gerekiyorsa tekrar filtre için kontrole gerek yok.
        return true;
      }
      this.setState({
        isFiltered: _filtered
      });
      if (hasFilter) {
        this.callRelateds(!_filtered);
      }
      return _filtered;
    }
  }, {
    key: "setColumns",
    value: function setColumns(newColumns) {
      this.setState({
        columns: newColumns
      });
    }
  }, {
    key: "setIsExpandedForExpandedRowKeys",
    value: function setIsExpandedForExpandedRowKeys(status) {
      this.isExpandedRef = status;
      this.setState({
        isExpanded: status
      });
    }
  }, {
    key: "setIsExpanded",
    value: function setIsExpanded(status) {
      this.setState({
        isExpanded: status
      });
    }
  }, {
    key: "updateRowField",
    value: function updateRowField(field, value) {
      var updatedRow = _objectSpread(_objectSpread({}, this.innerRowValueRef), {}, (0, _defineProperty2.default)({}, field, value));
      this.setState({
        innerRowValue: updatedRow
      });
      this.innerRowValueRef = _objectSpread({}, updatedRow);
      _tableContext.eventHub.setInnerData(_objectSpread({}, updatedRow), updatedRow.key);
    }
  }, {
    key: "setIsRowEditing",
    value: function setIsRowEditing(newValue) {
      this.setState({
        isRowEditing: newValue
      });
    }
  }, {
    key: "setIsDeleted",
    value: function setIsDeleted(newValue) {
      this.setState({
        isDeleted: newValue
      });
      if (typeof this.props.onDeleting == 'function') {
        this.props.onDeleting();
      }
    }
  }, {
    key: "updateRow",
    value: function updateRow(updatedRow) {
      var _filters = _tableContext.eventHub.getState('filters');
      this.setState({
        innerRowValue: updatedRow
      });
      this.checkFilter(_filters, true);
      this.innerRowValueRef = _objectSpread({}, updatedRow);
    }
  }, {
    key: "updateRowByFilter",
    value: function updateRowByFilter(updatedRow) {
      this.setState({
        innerRowValue: updatedRow,
        isExpanded: true,
        isFiltered: false
      });
      this.innerRowValueRef = _objectSpread({}, updatedRow);
    }
  }, {
    key: "getRowData",
    value: function getRowData() {
      return this.innerRowValueRef;
    }
  }, {
    key: "isFilterIgnore",
    value: function isFilterIgnore() {
      return Object.values(this.hierarchicallyFilteredRowKeys).some(Boolean);
    }

    // #endregion
  }, {
    key: "clearFilter",
    value: function clearFilter() {
      // filtre temizlendiyse satırı göster
      this.setState({
        isFiltered: false,
        isExpanded: !!this.isExpandedRef
      });
      this.hierarchicallyFilteredRowKeys = {};
    }
  }, {
    key: "callRelateds",
    value: function callRelateds(status) {
      /**
       * status
       *  true => show
       *  false => hide
       */
      var _this$props = this.props,
        checkFilterHierarchicallyUp = _this$props.checkFilterHierarchicallyUp,
        rowKey = _this$props.rowKey;
      if (typeof checkFilterHierarchicallyUp == 'function') {
        checkFilterHierarchicallyUp(rowKey, status);
      }

      // if (hasChildren) {
      //   eventHub.emit(`update.filters.hierarchically.down.${rowKey}`, status);
      // }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var checkfilterDidMount = this.props.checkfilterDidMount;
      if (checkfilterDidMount && Object.keys(checkfilterDidMount).length) {
        this.checkFilter(checkfilterDidMount);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unsubscriber.forEach(function (fn) {
        return fn();
      });
    }
  }, {
    key: "onDeleting",
    value: function onDeleting() {
      this.forceUpdate();
    }
  }, {
    key: "hasNonDeletedChildren",
    value: function hasNonDeletedChildren() {
      var innerRowValue = this.state.innerRowValue;
      var deletedRowKeys = _tableContext.eventHub.getState('deletedRowKeys') || [];
      if ((0, _ykbUtils.isNullOrUndefined)(innerRowValue.children)) {
        return false;
      }
      if (Array.isArray(innerRowValue.children) && innerRowValue.children.length == 0) {
        return true;
      }
      return innerRowValue.children.filter(function (child) {
        return !deletedRowKeys.some(function (val) {
          return val == child.key;
        });
      }).length > 0;
    }
  }, {
    key: "checkFilterHierarchicallyUpCallback",
    value: function checkFilterHierarchicallyUpCallback(childRowKey, status) {
      var _this$props2 = this.props,
        parentRowKey = _this$props2.parentRowKey,
        checkFilterHierarchicallyUp = _this$props2.checkFilterHierarchicallyUp,
        rowKey = _this$props2.rowKey;
      // status ; true => child showing && false => child filtering
      this.hierarchicallyFilteredRowKeys[childRowKey] = status;
      this.setState({
        isFiltered: !this.isFilterIgnore()
      });
      var onExpandByFilter = _tableContext.eventHub.getState('onExpandByFilter');
      if (this.isFilterIgnore()) {
        if (typeof onExpandByFilter == 'function') {
          onExpandByFilter(this.rowKey);
        }
        this.setState({
          isExpanded: true
        });
      }
      if (parentRowKey && typeof checkFilterHierarchicallyUp == 'function') {
        checkFilterHierarchicallyUp(rowKey, this.isFilterIgnore());
      }
    }
  }, {
    key: "enableListChildren",
    value: function enableListChildren() {
      var childrenListedGroups = _tableContext.eventHub.getState('childrenListedGroups') || [];
      if (this.filteredColumns.length == childrenListedGroups.length && (0, _ykbUtils.isEqual)(this.filteredColumns, childrenListedGroups)) {
        return true;
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        innerRowValue = _this$state.innerRowValue,
        isRowEditing = _this$state.isRowEditing,
        isFiltered = _this$state.isFiltered,
        isDeleted = _this$state.isDeleted,
        columns = _this$state.columns,
        isExpanded = _this$state.isExpanded;
      var _this$props3 = this.props,
        showChildForFilter = _this$props3.showChildForFilter,
        rowIndex = _this$props3.rowIndex,
        parentCollapsed = _this$props3.parentCollapsed,
        rowKey = _this$props3.rowKey,
        prefixCls = _this$props3.prefixCls,
        checkfilterDidMount = _this$props3.checkfilterDidMount;
      var hasChildren = this.hasNonDeletedChildren();
      var lastChildrenLength = this.innerRowValueRef.children ? this.innerRowValueRef.children.length : 0;
      this.innerRowValueRef = _objectSpread({}, innerRowValue);
      var checkfilterDidMountParams = {};
      if (innerRowValue.children && innerRowValue.children.length && innerRowValue.children.length != lastChildrenLength) {
        checkfilterDidMountParams = _objectSpread({}, this.filterParams);
      }
      var className = (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
        'editable-row': true,
        editing: isRowEditing,
        filtered: isFiltered && !showChildForFilter
      }, this.preparedClass, true), this.rowStyle(innerRowValue, rowIndex), true));
      if (isDeleted) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !parentCollapsed && /*#__PURE__*/_react.default.createElement("tr", {
        key: "".concat(this.rowUuid, "-tr"),
        className: className
      }, columns.map(function (column, index) {
        return /*#__PURE__*/_react.default.createElement(_TestEditableCell.default, {
          columnDef: column,
          row: innerRowValue,
          rowKey: rowKey,
          depth: _this2.depth,
          key: "".concat(rowKey, "-").concat(column.dataIndex),
          prefixCls: prefixCls,
          id: "".concat(_this2.rowId, "_").concat(column.dataIndex),
          cellIndex: index,
          hasChildren: hasChildren,
          isExpanded: isExpanded,
          rowId: _this2.rowId,
          rowIndex: rowIndex,
          isFiltered: isFiltered && !showChildForFilter,
          isActiveFilter: !!_this2.filteredColumns.length,
          showChildForFilter: showChildForFilter
        });
      })), hasChildren && innerRowValue.children.map(function (_row, index) {
        var _rowKey = typeof _this2.getRowKey == 'function' ? _this2.getRowKey(_row) : _row[_this2.getRowKey];
        return /*#__PURE__*/_react.default.createElement(FormRow2, {
          row: _row,
          prefixCls: prefixCls,
          rowKey: _rowKey,
          key: _rowKey,
          depth: _this2.depth + 1,
          rowIndex: index,
          rowStyle: _this2.rowStyle,
          parentRowIndex: _this2.rowId,
          parentRowKey: rowKey
          // parentCollapsed={childCollapsed}
          ,
          parentCollapsed: isExpanded && parentCollapsed || !isExpanded,
          checkfilterDidMount: checkfilterDidMount || checkfilterDidMountParams,
          checkFilterHierarchicallyUp: _this2.checkFilterHierarchicallyUpCallback,
          showChildForFilter: Object.keys(_this2.filterParams).length > 0 && (_this2.isFilteredRef == false || showChildForFilter) && _this2.enableListChildren(),
          onDeleting: _this2.onDeleting,
          parentRowsPath: _this2.rowPath
        });
      }));
    }
  }]);
}(_react.default.PureComponent);